import React, { useEffect, useState } from 'react' 
import { NavLink, useNavigate } from 'react-router-dom'   
import { toast, ToastContainer } from 'react-toastify';
import { Api_Url } from './APIUrl';

const Kyc3 = () => { 
  //   const [frontFileName, setFrontFileName] = useState("Upload front Photo of your Aadhar Card.");
  //   const [backFileName, setBackFileName] = useState("Upload back Photo of your Aadhar Card.");
  //   const [selectedDate, setSelectedDate] = useState("");
  // const [number , setnumber] = useState();
  // const [Email , setEmail] = useState();

  const [Email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [frontPhoto, setFrontPhoto] = useState(null);
  const [backPhoto, setBackPhoto] = useState(null);
  const [frontFileName, setFrontFileName] = useState("");
  const [backFileName, setBackFileName] = useState("");
  const [errors, setErrors] = useState({}); // State to track errors

  // const handleFrontFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     // Check file size
  //     if (file.size > 2 * 1024 * 1024) { // 2MB
  //       toast.error("File size should not exceed 2MB");
  //       return;
  //     }
  //     // Check file type
  //     const validTypes = ["image/jpeg", "image/png", "image/jpg"];
  //     if (!validTypes.includes(file.type)) {
  //       toast.error("Only JPG, PNG, and JPEG files are allowed");
  //       return;
  //     }
  //     setFrontPhoto(file);
  //     setFrontFileName(file.name);
  //   }
  // };
  
  // const handleBackFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     // Check file size
  //     if (file.size > 2 * 1024 * 1024) { // 2MB
  //       toast.error("File size should not exceed 2MB");
  //       return;
  //     }
  //     // Check file type
  //     const validTypes = ["image/jpeg", "image/png", "image/jpg"];
  //     if (!validTypes.includes(file.type)) {
  //       toast.error("Only JPG, PNG, and JPEG files are allowed");
  //       return;
  //     }
  //     setBackPhoto(file);
  //     setBackFileName(file.name);
  //   }
  // };
  
  
  
  const handleFrontFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFrontPhoto(file);
      setFrontFileName(file.name);
  
      // Clear error for front photo
      setErrors((prevErrors) => ({ ...prevErrors, frontPhoto: null }));
    }
  };
  
  const handleBackFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBackPhoto(file);
      setBackFileName(file.name);
  
      // Clear error for back photo
      setErrors((prevErrors) => ({ ...prevErrors, backPhoto: null }));
    }
  };
  
  const Navigate= useNavigate()
  useEffect(() => { 
    if(!localStorage.getItem('token')){ 
        Navigate("/") 
    }
  }, [])



   const validations = () =>{
  
    if(!Email){
      toast("The email field is required.")
    }
    else if(!number){
      toast("The aadhaar number field is required.")
    }
    else if(!frontPhoto){
      toast("The aadhaar front photo field must be an image. The aadhaar front photo field must be a file of type: jpeg, png, jpg.")
    }
    else if(!backPhoto){
      toast("The aadhaar back photo field must be an image.")
    }
    else{ 
    }
  } 
  
  const verify = () => {
    const newErrors = {};
    if (!Email) newErrors.Email = "Email is required.";
    if (!number) newErrors.number = "Aadhar Number is required.";
    if (number && number.length !== 12)
      newErrors.number = "Aadhar Number must be 12 digits.";
    if (!frontPhoto) newErrors.frontPhoto = "Aadhaar Front Photo is required.";
    if (!backPhoto) newErrors.backPhoto = "Aadhaar Back Photo is required.";
  
    setErrors(newErrors);
  
    // Stop submission if there are errors
    if (Object.keys(newErrors).length > 0) return;
  
    try {
      const myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        `Bearer ${localStorage.getItem("token")}`
      );
  
      const formdata = new FormData();
      formdata.append("aadhaar_number", number);
      formdata.append("email", Email);
      formdata.append("aadhaar_front_photo", frontPhoto);
      formdata.append("aadhaar_back_photo", backPhoto);
  
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
  
      fetch(`${Api_Url}api/apply-kyc`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success === true) {
            toast(result?.message);
            setErrors({});  
          }else if (result.message === "Token has expired.") { 
            localStorage.removeItem("token");   
            window.location.href = "/";   
          } else {
            // Handle API errors and display them in their respective fields
            const apiErrors = {};
  
            if (result.error?.email) apiErrors.Email = result.error.email;
            if (result.error?.aadhaar_number)
              apiErrors.number = result.error.aadhaar_number;
            if (result.error?.aadhaar_front_photo)
              apiErrors.frontPhoto = result.error.aadhaar_front_photo;
            if (result.error?.aadhaar_back_photo)
              apiErrors.backPhoto = result.error.aadhaar_back_photo;
  
            setErrors(apiErrors);
  
            // Optionally show a toast for generic error messages
            if (result.message) toast(result.message, { type: "error" });
          }
        })
        .catch((error) => console.error(error));
    } catch (error) {
      toast(error?.message);
    }
  };
  

  
  return (
    <div>

      <ToastContainer/>
        <div className='container'  >
            <div className='row'>
                <div className='col-lg-12 col-sm-12  mt-5 pt-5'> 
                    <p style={{color:'#959595'}}>You need to submit a document that shows that you are above 18 years of age and not a resident of <strong> Assam, Odisha, Sikkim, Nagaland, Telangana, Andhra Pradesh, Tamil Nadu and Karnataka.</strong>
                    </p>



<p style={{color:'#959595'}}>Enter details of Aadhar Card:</p>

 

    <div>
      {/* Email Field */}
      <div className="mb-3">
        <label htmlFor="exampleInputEmail1" className="form-label">
          Email id
        </label>
        <input
          type="text"
          className={`form-control py-2 ${
            errors.Email ? "border-danger" : ""
          }`}
          value={Email}
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder="EMAIL"
          onChange={(e) => {
            setEmail(e.target.value);
            setErrors((prev) => ({ ...prev, Email: "" })); // Clear error on change
          }}
          style={{ boxShadow: "none", border: "1px solid #ffcc5b" }}
        />
        {errors.Email && <div className="text-danger">{errors.Email}</div>}
      </div>

      {/* Aadhar Number Field */}
      <div className="mb-3">
        <label htmlFor="exampleInputAadhar" className="form-label">
          Aadhar Number
        </label>
        <input
          type="number"
          className={`form-control py-2 ${
            errors.number ? "border-danger" : ""
          }`}
          value={number}
          id="exampleInputAadhar"
          aria-describedby="aadharHelp"
          placeholder="AADHAR NUMBER"
          onChange={(e) => {
            const value = e.target.value;
            if (value.length <= 12) {
              setNumber(value);
              setErrors((prev) => ({ ...prev, number: "" })); // Clear error on change
            }
          }}
          style={{ boxShadow: "none", border: "1px solid #ffcc5b", textWrap:'wrap' }}
        />
        {errors.number && <div className="text-danger">{errors.number}</div>}
      </div>

      {/* Front Photo Upload */}
      <div style={{ margin: "auto" }}>
        <label
          htmlFor="front-upload"
          style={{
            display: "block",
            border: errors.frontPhoto ? "2px dashed red" : "1px dashed #ccc",
            borderRadius: "8px",
            padding: "20px",
            textAlign: "center",
            cursor: "pointer",
            marginBottom: "20px",  wordWrap: "break-word",  
            wordBreak: "break-word",
          }}
        >
          {frontFileName || "Upload Aadhaar Front Photo"}
        </label>
        <input
          id="front-upload"
          type="file"
          onChange={(e) => handleFrontFileChange(e)}
          style={{ display: "none" }}
        />
        {errors.frontPhoto && (
          <div className="text-danger">{errors.frontPhoto}</div>
        )}

        {/* Back Photo Upload */}
        <label
          htmlFor="back-upload"
          style={{
            display: "block",
            border: errors.backPhoto ? "2px dashed red" : "1px dashed #ccc",
            borderRadius: "8px",
            padding: "20px",
            textAlign: "center",
            cursor: "pointer",
            wordWrap: "break-word",  
            wordBreak: "break-word",
          }}
        >
          {backFileName || "Upload Aadhaar Back Photo"}
        </label>
        <input
          id="back-upload"
          type="file"
          onChange={(e) => handleBackFileChange(e)}
          style={{ display: "none",textWrap:'wrap' }}
        />
        {errors.backPhoto && (
          <div className="text-danger">{errors.backPhoto}</div>
        )}
      </div>

      {/* Submit Button */}
      <div>
        <button
          className="btn w-100 py-2 my-4"
          style={{ backgroundColor: "#00d25b", color: "#fff" }}
          onClick={verify}
        >
          SUBMIT
        </button>
      </div>
    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Kyc3